import React, { useCallback, useRef } from 'react';
import Lottie, { LottieRefCurrentProps } from 'lottie-react';
import sparklesAnimationData from '../../organisms/OChat/chat-sparkles.lottie.json';

export interface ChatSparklesLottieProps {
  /** Pixel size for both width and height (default 100) */
  size?: number;
  className?: string;
}

/**
 * Animated sparkles icon used on the Welcome screen after login.
 * Plays the Lottie animation once, then holds on the final frame indefinitely.
 */
export const ChatSparklesLottie: React.FC<ChatSparklesLottieProps> = ({ size = 100, className }) => {
  const lottieRef = useRef<LottieRefCurrentProps>(null);

  const handleComplete = useCallback(() => {
    const anim = lottieRef.current;
    if (!anim) return;
    const totalFrames = anim.getDuration(true);
    if (totalFrames == null) return;
    anim.goToAndStop(totalFrames - 1, true);
  }, []);

  return (
    <div style={{ width: size, height: size, flexShrink: 0 }} className={className} aria-hidden="true">
      <Lottie
        lottieRef={lottieRef}
        animationData={sparklesAnimationData}
        loop={false}
        autoplay
        onComplete={handleComplete}
        style={{ width: size, height: size }}
      />
    </div>
  );
};

export default ChatSparklesLottie;
